import { useEffect, useState } from "react";
import { getToken } from "../../../services/authService";

export function useEventoDetalleData(eventoId, apiUrl) {
    const [loading, setLoading] = useState(true);
    const [notice, setNotice] = useState("");
    const [evento, setEvento] = useState(null);

    const [catalogos, setCatalogos] = useState({
        personas: [],
        habitaciones: [],
        platos: [],
        vinos: [],
        roles: [],
        armas: [],
    });

    useEffect(() => {
        if (!eventoId) return;

        (async () => {
            setLoading(true);
            setNotice("");

            try {
                const token = getToken();
                const headers = { Authorization: `Bearer ${token}` };

                const [evRes, personasRes, habitacionesRes, platosRes, vinosRes, rolesRes, armasRes] =
                    await Promise.all([
                        fetch(`${apiUrl}/api/eventos/${eventoId}`, { headers }),
                        fetch(`${apiUrl}/api/personas/activas`, { headers }),
                        fetch(`${apiUrl}/api/habitaciones/disponibles`, { headers }),
                        fetch(`${apiUrl}/api/plato/all`, { headers }),
                        fetch(`${apiUrl}/api/vinos/all`, { headers }),
                        fetch(`${apiUrl}/api/roles/all`, { headers }),
                        fetch(`${apiUrl}/api/armas/all`, { headers }),
                    ]);

                if (!evRes.ok) throw new Error(await evRes.text());
                setEvento(await evRes.json());

                setCatalogos({
                    personas: await personasRes.json(),
                    habitaciones: await habitacionesRes.json(),
                    platos: await platosRes.json(),
                    vinos: await vinosRes.json(),
                    roles: await rolesRes.json(),
                    armas: await armasRes.json(),
                });
            } catch (e) {
                console.error(e);
                setNotice(e?.message || "Error cargando el evento.");
            } finally {
                setLoading(false);
            }
        })();
    }, [eventoId, apiUrl]);

    return { loading, notice, evento, catalogos };
}
